import React from "react";

import { cn } from "@/lib/utils";

export default function Header({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <h2 className={cn("lg:mb-8 mb-6 px-5 text-left lg:text-center text-h3 lg:text-h2", className)}>
      {children}
    </h2>
  );
}
